const GET_BULK_ORDER_GRID_COUNT = 'GET_BULK_ORDER_GRID_COUNT';
const SET_BULK_ORDER_GRID_COUNT = 'SET_BULK_ORDER_GRID_COUNT';

const GET_BULK_ORDER_GRID_DATA = 'GET_BULK_ORDER_GRID_DATA';
const SET_BULK_ORDER_GRID_DATA = 'SET_BULK_ORDER_GRID_DATA';

const IS_BULK_ORDER_GRID_LOADING = 'IS_BULK_ORDER_GRID_LOADING'
const IS_BULK_ORDER_GRID_COUNTS_LOADING = 'IS_BULK_ORDER_GRID_COUNTS_LOADING'

export
{
    GET_BULK_ORDER_GRID_COUNT,
    SET_BULK_ORDER_GRID_COUNT,
    GET_BULK_ORDER_GRID_DATA,
    SET_BULK_ORDER_GRID_DATA,
    IS_BULK_ORDER_GRID_LOADING,
    IS_BULK_ORDER_GRID_COUNTS_LOADING
};